import { BadgeVerifications, VerifiableCredential } from "../domain";

export const fetchBadgeVerifications = async ({
  ethereumAddress,
}: {
  ethereumAddress: string;
}): Promise<BadgeVerifications> => {
  try {
    const url = `${import.meta.env.VITE_APP_BACKEND_URL}/badges`;
    const res = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        did: `did:pkh:eip155:1:${ethereumAddress}`,
      }),
    });

    if (res.ok) {
      return (await res.json()) as BadgeVerifications;
    } else {
      throw new Error(res.statusText);
    }
  } catch (e) {
    console.error(e);
    throw new Error("An error occurred while loading the badges");
  }
};

export const sendPhoneVerificationCode = async ({
  ethereumAddress,
  phone,
}: {
  ethereumAddress: string;
  phone: string;
}) => {
  try {
    const url = `${import.meta.env.VITE_APP_BACKEND_URL}/phone/sendCode`;
    const res = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        did: `did:pkh:eip155:1:${ethereumAddress}`,
        phone,
      }),
    });

    if (res.ok) {
      return;
    } else {
      throw new Error(res.statusText);
    }
  } catch (e) {
    console.error(e);
    throw new Error("An error occurred while sending the verification code");
  }
};

export const verifyPhoneCode = async ({
  ethereumAddress,
  phone,
  code,
}: {
  ethereumAddress: string;
  phone: string;
  code: string;
}) => {
  try {
    const url = `${import.meta.env.VITE_APP_BACKEND_URL}/phone/verifyCode`;
    const res = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        did: `did:pkh:eip155:1:${ethereumAddress}`,
        phone,
        code,
      }),
    });

    if (res.ok) {
      return;
    } else {
      throw new Error(res.statusText);
    }
  } catch (e) {
    console.error(e);
    throw new Error("An error occurred while verifying the code");
  }
};

export const verifyGitHubCode = async ({
  ethereumAddress,
  code,
}: {
  ethereumAddress: string;
  code: string;
}): Promise<void> => {
  try {
    const url = `${import.meta.env.VITE_APP_BACKEND_URL}/github/verify`;
    const res = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        did: `did:pkh:eip155:1:${ethereumAddress}`,
        code,
      }),
    });

    if (res.ok) {
      return;
    } else {
      throw new Error(res.statusText);
    }
  } catch (e) {
    console.error(e);
    throw new Error("An error occurred while verifying the code");
  }
};

export const fetchVerifiableCredential = async ({
  ethereumAddress,
}: {
  ethereumAddress: string;
}): Promise<VerifiableCredential> => {
  try {
    const url = `${import.meta.env.VITE_APP_BACKEND_URL}/vcbjj`;
    const res = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        did: `did:pkh:eip155:1:${ethereumAddress}`,
      }),
    });

    if (res.ok) {
      return (await res.json()) as VerifiableCredential;
    } else {
      throw new Error(res.statusText);
    }
  } catch (e) {
    console.error(e);
    throw new Error(
      "An error occurred while requestin the verifiable credential"
    );
  }
};
